import RevenueWidget, { meta as revenueMeta } from './widgets/RevenueWidget.vue';
import ExpensesWidget, { meta as expensesMeta } from './widgets/ExpensesWidget.vue';
import OutstandingWidget, { meta as outstandingMeta } from './widgets/OutstandingWidget.vue';
import PayablesWidget, { meta as payablesMeta } from './widgets/PayablesWidget.vue';
import PaymentMethodsWidget, { meta as paymentMethodsMeta } from './widgets/PaymentMethodsWidget.vue';
import WeatherWidget, { meta as weatherMeta } from './widgets/WeatherWidget.vue';
import CashRegisterWidget, { meta as cashRegisterMeta } from './widgets/CashRegisterWidget.vue';
import LowStockWidget, { meta as lowStockMeta } from './widgets/LowStockWidget.vue';
import StockWidget, { meta as stockMeta } from './widgets/StockWidget.vue';
import StorageSimpleWidget, { meta as storageSimpleMeta } from './widgets/StorageSimpleWidget.vue';
import SubscriptionsWidget, { meta as subscriptionsMeta } from './widgets/SubscriptionsWidget.vue';
import SubscriptionSummaryWidget, { meta as subscriptionSummaryMeta } from './widgets/SubscriptionSummaryWidget.vue';
import SmsCreditWidget, { meta as smsCreditMeta } from './widgets/SmsCreditWidget.vue';
import StorageWidget, { meta as storageMeta } from './widgets/StorageWidget.vue';
import AgendaUpcomingWidget, { meta as agendaUpcomingMeta } from './widgets/AgendaUpcomingWidget.vue';
import WorkOrderRecentWidget, { meta as workOrderRecentMeta } from './widgets/WorkOrderRecentWidget.vue';
import WorkOrderStatusWidget, { meta as workOrderStatusMeta } from './widgets/WorkOrderStatusWidget.vue';
import SmsCreditSimpleWidget, { meta as smsCreditSimpleMeta } from './widgets/SmsCreditSimpleWidget.vue';
import SmsTitlesWidget, { meta as smsTitlesMeta } from './widgets/SmsTitlesWidget.vue';
import AgendaStatsWidget, { meta as agendaStatsMeta } from './widgets/AgendaStatsWidget.vue';

export const widgetRegistry = [
    { ...revenueMeta, component: RevenueWidget },
    { ...expensesMeta, component: ExpensesWidget },
    { ...outstandingMeta, component: OutstandingWidget },
    { ...payablesMeta, component: PayablesWidget },
    { ...paymentMethodsMeta, component: PaymentMethodsWidget },
    { ...weatherMeta, component: WeatherWidget },
    { ...cashRegisterMeta, component: CashRegisterWidget },
    { ...lowStockMeta, component: LowStockWidget },
    { ...stockMeta, component: StockWidget },
    { ...storageSimpleMeta, component: StorageSimpleWidget },
    { ...subscriptionsMeta, component: SubscriptionsWidget },
    { ...subscriptionSummaryMeta, component: SubscriptionSummaryWidget },
    { ...smsCreditMeta, component: SmsCreditWidget },
    { ...storageMeta, component: StorageWidget },
    { ...agendaUpcomingMeta, component: AgendaUpcomingWidget },
    { ...workOrderRecentMeta, component: WorkOrderRecentWidget },
    { ...workOrderStatusMeta, component: WorkOrderStatusWidget },
    { ...smsCreditSimpleMeta, component: SmsCreditSimpleWidget },
    { ...smsTitlesMeta, component: SmsTitlesWidget },
    { ...agendaStatsMeta, component: AgendaStatsWidget },
];

export const defaultOrder = widgetRegistry.map(w => w.id);

export function getWidget(id) {
    return widgetRegistry.find(w => w.id === id);
}

export function getTemplate(templateId) {
    return widgetRegistry.find(w => w.id === templateId) || null;
}
